import React, { createContext, useContext, useState } from 'react';

const TicketContext = createContext();

export const TicketProvider = ({ children }) => {
  const [ticketDetails, setTicketDetails] = useState({
    tickets: [],
    total: 0,
    eventDetails: null
  });

  const updateTicketDetails = (newDetails) => {
    setTicketDetails(newDetails);
  };

  return (
    <TicketContext.Provider value={{ ticketDetails, updateTicketDetails }}>
      {children}
    </TicketContext.Provider>
  );
};

export const useTicket = () => {
  const context = useContext(TicketContext);
  if (!context) {
    throw new Error('useTicket must be used within a TicketProvider');
  }
  return context;
}; 